import type { PanelPlugin } from './types'

// Excalidraw canvas as a panel contribution (same family as voice/document). Rendering it through the
// panel host means it inherits Whimer's responsive frame for free: a side column on desktop, a
// full-screen swap with the header view-toggle on mobile — no bespoke overlay that traps the user.
//
// The body is a sandboxed iframe loading the canvas page served same-origin at /canvas/ (proxied by
// serve.cjs to the excalidraw kind:service plugin). The page scopes to this chat via ?chat=<id>, so
// the agent's get_scene/set_scene and the user's edits all share one per-chat canvas.
export const canvasPanel: PanelPlugin = {
  id: 'canvas',
  title: 'Canvas',
  icon: 'pencil',
  render: ({ chatId }) => (
    <iframe
      key={chatId}
      src={`/canvas/?chat=${encodeURIComponent(chatId)}`}
      title="Canvas"
      style={{ width: '100%', height: '100%', flex: 1, minHeight: 0, border: 'none' }}
      sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-pointer-lock allow-downloads"
      allow="clipboard-read; clipboard-write"
    />
  ),
}
